import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import EudrDashboardService from 'src/modules/3rd-party-management/apis/admin/EudrDashboardService';

export const EUDR_SUPPLIER_STATUS_QUERY_KEY = '3rd-party-management-fetch-eudr-supplier-status';

const useSupplierStatus = ({
    t,
}) => {
    const query = useQuery({
        queryKey: [EUDR_SUPPLIER_STATUS_QUERY_KEY],
        queryFn: async () => {
            const service = EudrDashboardService.getInstance();

            return await service.fetchSupplierStatus();
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') console.error(error);

            toast(t('An error occurred while fetching EUDR supplier status data.'), {
                type: 'error',
            });
        },
    });

    const data = query.data;

    if (!data) {
        return {
            ...query,
            segments: null,
            total: 0,
        };
    }

    const segments = data.map((item) => ({
        label: t(item.label),
        value: Number(item.value) || 0,
        color: item.color,
    }));

    const total = segments.reduce((sum, item) => sum + item.value, 0);

    return {
        ...query,
        segments,
        total,
    };
};

export default useSupplierStatus;
